<template>
    <div>
        <v-layout row wrap v-if="isRoot">
            <v-flex xs10 lg8 offset-xs1 offset-lg2>
                <v-card class="pa-2">
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs10>
                                <p class="subheading ma-0" style="font-weight:500">Secretarias</p>
                                <p class="grey--text text--darken-1 ma-0">Adiciona ou altera secretarias.</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-btn @click="manageOffices" style="margin-top:15px">
                                Acessar
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-3" v-if="isRoot || isAdmin">
            <v-flex xs10 lg8 offset-xs1 offset-lg2>
                <v-card class="pa-2">
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs10>
                                <p class="subheading ma-0" style="font-weight:500">Áreas</p>
                                <p class="grey--text text--darken-1 ma-0">Adiciona ou altera áreas.</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-btn @click="manageAreas" style="margin-top:15px">
                                Acessar
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-3" v-if="isRoot || isAdmin || isHired">
            <v-flex xs10 lg8 offset-xs1 offset-lg2>
                <v-card class="pa-2">
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs10>
                                <p class="subheading ma-0" style="font-weight:500">Report</p>
                                <p class="grey--text text--darken-1 ma-0">Gerar relatórios de faturamento de demandas</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-btn @click="createReport" style="margin-top:15px">
                                Acessar
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>

export default {
    data() {
        return {
        };
    },

    computed: {
        isRoot() {
            return this.$store.getters.profile.isRoot;
        },
        isAdmin() {
            return this.$store.getters.profile.isAdmin;
        },
        isHired() {
            return this.$store.getters.profile.person.isHired;
        },
    },

    methods: {
        manageOffices() {
            this.$router.push({ name: 'officeIndex' });
        },
        manageAreas() {
            this.$router.push({ name: 'areaIndex' });
        },
        createReport() {
            this.$router.push({ name: 'demandBillingReport' });
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/admin/Index.vue